import React, { useEffect, useState } from 'react'
import ConfirmationView from './components/ConfirmationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'
import { useSelector } from 'react-redux';

const Confirmation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  const addressTypeChange = useSelector((state) => state.app.addressTypeChange);
  useEffect(() => {
    try {
      addToGoogleDataLayer('confirmation', 'Pay a Debt', i18n.language, addressTypeChange)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [i18n.language, addressTypeChange])

  return isError ? <Error /> : <ConfirmationView setIsError={setIsError} />
}

export default withTranslation('common')(Confirmation)
